import { Component, Inject, INJECTOR, Injector } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NanoDialogBaseComponent } from '../nano-base-dialog';

@Component({
  selector: 'app-waiting-dialog',
  templateUrl: './waiting-dialog.component.html',
  styleUrls: ['./waiting-dialog.component.scss'],
})
export class WaitingDialogComponent extends NanoDialogBaseComponent<WaitingDialogComponent> {
  constructor(
    @Inject(INJECTOR) injector: Injector,
    @Inject(MAT_DIALOG_DATA) public dialogData: WaitingDialogData,
    public translate: TranslateService
  ) {
    super(injector);
  }

  closeWithOk() {
    this.dialogRef.close(true);
  }
}

export interface WaitingDialogData {
  title: string;
  text: string;
}
